var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"label":_vm.label,"items":_vm.items,"item-text":_vm.itemText,"item-value":_vm.itemValue,"return-object":!_vm.itemValue},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }